module.exports = __webpack_public_path__ + "img/10.4e0b1c5.png";